/* jshint ignore:start */
/* eslint-disable */
const toggleFullScreen = () => {
    let doc = window.document;
    let docEl = doc.documentElement;

    let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
    let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

    if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
        requestFullScreen.call(docEl);
    } else {
        cancelFullScreen.call(doc);
    }
};
const isEmpty = (value) => {
    return (value != undefined && value != null && value.toString().trim().length > 0) ? true : false
}
const formatNumber = (value, digit, hasComma) => {
    if (hasComma) {
        value = value.toLocaleString(undefined, {
            maximumFractionDigits: digit
        });
    }
    return value
};
const formatDate = (newDate, format_type) => {
    let __date = new Date(newDate)
    let __month = (__date.getMonth() + 1)
    let __day = __date.getDate()
    let __year = __date.getFullYear()
    let result = null;

    if (__month.toString().length < 2) {
        __month = '0' + __month
    }
    if (__day.toString().length < 2) {
        __day = '0' + __day
    }

    switch (format_type) {
        case "0":
            result = [__day, __month, (__year + 543)].join('/')
            break;
        default:
            result = [__year, __month, __day].join('-')
            break;
    }

    if (newDate.toString().includes(' ')) {
        let sptData = newDate.split(' ')
        if (sptData.toString().length > 0) {
            let sptTime = sptData[1].split(':')
            result += ' ' + sptTime[0] + ':' + sptTime[1]
        }
    }
    return result
};
const formatDates = (newDate, format_type) => {
    let __date = new Date(newDate)
    let __month = (__date.getMonth() + 1)
    let __day = __date.getDate()
    let __year = __date.getFullYear()
    let result = null;

    if (__month.toString().length < 2) {
        __month = '0' + __month
    }
    if (__day.toString().length < 2) {
        __day = '0' + __day
    }

    switch (format_type) {
        case "0":
            result = [__day, __month, (__year + 543)].join('/')
            break;
        default:
            result = [ __day, __month,__year].join('-')
            break;
    }

    if (newDate.toString().includes(' ')) {
        let sptData = newDate.split(' ')
        if (sptData.toString().length > 0) {
            let sptTime = sptData[1].split(':')
            result += ' ' + sptTime[0] + ':' + sptTime[1]
        }
    }
    return result
};
const getMonthName = (newDate) => {
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    let month = new Date(newDate).getMonth();
    return monthNames[month]
};
const formatTime = (newTime) => {
    let result = null;
    let sptTime = newTime.split(':')
    result = sptTime[0] + ':' + sptTime[1]
    return result;
};
const newGuid = (head) => {
    return head + '-xxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 8 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};
export default {
    toggleFullScreen,
    formatNumber,
    formatDate,
    getMonthName,
    formatTime,
    isEmpty,
    newGuid
}